import { t } from "../../../lib/sprache";
import { tarifName } from "../../../model/tarif";
import { usage } from "./model";
import type { GroupOverview } from "./data";

/**
 * Enterprise-Verbund (0174) auf Abo & Tarif: Tarif der Hauptagentur, Verbrauch der ganzen Gruppe gegen die gemeinsamen Grenzen,
 * für Gruppen-Admins zusätzlich Standorte, Admins und vorgemerkte Aufnahmen. Den Verbund selbst ändert nur der Plattform-Betrieb.
 */
export function VerbundPanel({ g, orgId }: { g: GroupOverview; orgId: string }) {
  const haupt = g.billing_org_id === orgId;
  const zeilen = [
    { label: t("Creator", "creators"), ...usage(g.talents, g.max_talents) },
    { label: t("Team-Plätze", "Team seats"), ...usage(g.seats, g.max_seats) },
  ];
  return (
    <section className="panel stack" aria-labelledby="verbund-titel">
      <h2 id="verbund-titel">{t("Verbund ", "Group ")}{g.name}</h2>
      <p>
        {haupt
          ? t("Diese Agentur ist die Hauptagentur des Verbunds: ihr Abo gilt für alle Standorte.", "This agency is the group's main agency: its subscription covers all locations.")
          : t(`Abo und Tarif laufen über die Hauptagentur ${g.billing_org_name ?? ""}. Rechnungen und Zahlungen erledigt sie für alle Standorte.`, `Subscription and plan run through the main agency ${g.billing_org_name ?? ""}. It handles invoices and payments for all locations.`)}
        {g.plan_key ? t(` Tarif: ${tarifName(g.plan_key)}.`, ` Plan: ${tarifName(g.plan_key)}.`) : ""}
      </p>
      <p>{t("Grenzen gelten für den ganzen Verbund zusammen: ", "Limits apply to the whole group together: ")}{zeilen.map((z) => `${z.text} ${z.label}`).join(" · ")}</p>
      {g.orgs && (
        <div className="tablewrap">
          <table>
            <caption className="sr-only">{t("Standorte im Verbund", "Locations in the group")}</caption>
            <thead><tr><th scope="col">{t("Agentur", "Agency")}</th><th scope="col">{t("Creator", "Creators")}</th><th scope="col">{t("Team-Plätze", "Team seats")}</th></tr></thead>
            <tbody>
              {g.orgs.map((o) => (
                <tr key={o.id}>
                  <td>{o.name}{o.is_billing ? <> <span className="pill info">{t("Hauptagentur", "Main agency")}</span></> : null}{o.id === orgId ? <small> {t("(diese)", "(this one)")}</small> : null}</td>
                  <td className="num">{o.talents}</td>
                  <td className="num">{o.seats}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {g.pending && g.pending.length > 0 && (
        <p>{t("Aufnahme vorgemerkt (sobald deren eigenes Abo endet): ", "Joining scheduled (once their own subscription ends): ")}{g.pending.map((p) => p.name).join(", ")}</p>
      )}
      {g.admins && g.admins.length > 0 && (
        <p>{t("Gruppen-Admins (in jedem Standort Admin, belegen keinen Platz): ", "Group admins (admin in every location, use no seat): ")}{g.admins.map((a) => a.email).join(", ")}</p>
      )}
      <small>{t("Standorte aufnehmen oder entfernen und Gruppen-Admins ändern: bitte an support@creatoroffice.de.", "To add or remove locations or change group admins, please write to support@creatoroffice.de.")}</small>
    </section>
  );
}
